import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import selectors from '../../store/selectors';
import SEO from '../seo';
import { ThemeContext } from '../Theme';

import AddParishLink from './AddParishLink';

const enhance = connect(state => ({
  parishData: selectors.getAccountData(state),
}));

const Header = ({ parishData, description, customColors = {} }) => {
  const { hideHeader } = useContext(ThemeContext);

  // @TODO: refactor customColors to be dynamic account option
  const headerStyle = {};
  const navStyle = {};
  if (customColors !== undefined) {
    if (customColors.primary !== undefined) {
      navStyle.color = `${customColors.primary} !important`;
    }
    if (customColors.secondary !== undefined) {
      headerStyle.backgroundColor = `${customColors.secondary} !important`;
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <body className="mt-0 w-100 h-100 antdResetWrapper" />
      </Helmet>

      <SEO
        title={parishData.full_name}
        description={description}
        meta={[
          { name: 'apple-mobile-web-app-title', content: parishData.full_name },
          { name: 'application-name', content: parishData.full_name },
        ]}
      />

      {!hideHeader && (
        <header className="light-blue darken-4" style={headerStyle}>
          <nav className="navbar text-white justify-content-start flex-nowrap" style={navStyle}>
            <div className="logo">
              <img alt="" className="z-depth-1" src={parishData.avatar_url} />
            </div>
            <div className="ml-3" style={navStyle}>
              <span className="d-md-none" style={navStyle}>
                {parishData.short_name}
              </span>
              <span className="d-none d-md-block" style={navStyle}>
                {parishData.full_name}
              </span>
            </div>

            <span className="d-none d-lg-inline-block add-parish">
              <AddParishLink />
            </span>
          </nav>
        </header>
      )}
    </React.Fragment>
  );
};

Header.propTypes = {
  parishData: PropTypes.shape({
    avatar_url: PropTypes.string,
    short_name: PropTypes.string,
    full_name: PropTypes.string,
  }),
  description: PropTypes.string,
  customColors: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string,
  }),
};

export default enhance(Header);
